/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

import dateFormat from '@/tools/dateFormat';
import { invoiceStatus } from './search';
import { moneyInt } from '@/tools/money';
import Detail from '../components/detail';
import Add from '../components/add';
function handleEmpty(r, c, v) {
  return v || '-';
}
const statusMap = {
  0: '生成中',
  1: '生成中',
  2: '完成',
  3: '失败'
};
export default {
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  xsf: {
    label: '销售方',
    prop: 'csoEnterpriseName',
    formatter: handleEmpty
  },
  xsfNo: {
    label: '纳税人识别号',
    prop: 'invoiceIdentifierNo',
    formatter: handleEmpty
  },
  money: {
    label: '价税合计',
    formatter: row => {
      return `${moneyInt(row['invoiceAmount'] || 0)}元`;
    }
  },
  invoiceCatalogue: {
    label: '发票类目',
    prop: 'itemName',
    formatter: handleEmpty
  },
  invoiceType: {
    label: '发票类别',
    prop: 'invoiceTypeName',
    formatter: handleEmpty
  },
  invoiceStatus: {
    label: '发票状态',
    prop: 'invoiceStatus',
    render: function(h, ctx, r, c) {
      const { invoiceStatus: _invoiceStatus, noPassReason } = r;
      if (_invoiceStatus == 3 && noPassReason) {
        return (
          <el-button
            type="text"
            onClick={() => {
              ctx.parent.$alert(noPassReason);
            }}
          >
            已驳回
          </el-button>
        );
      }
      return <span>{(invoiceStatus[_invoiceStatus] || {}).name}</span>;
    }
  },
  applyDt: {
    label: '申请时间',
    prop: 'createDt',
    formatter(r, c, v) {
      return v ? dateFormat(v) : '-';
    }
  },
  billingDt: {
    label: '开票时间',
    prop: 'openDt',
    formatter(r, c, v) {
      return v ? dateFormat(v) : '-';
    }
  },
  operation: {
    label: '操作',
    width: '120px',
    render: function(h, ctx, r, c) {
      const vm = ctx.parent;
      const { id, invoiceStatus } = r;
      return (
        <div>
          <el-button
            type="text"
            onClick={() => {
              vm.$xrkDialog({
                title: '发票详情',
                width: '90vw',
                showCancel: false,
                showConfirm: false,
                $slots: {
                  default: vm.$createElement(
                    invoiceStatus == 0 ? Add : Detail,
                    {
                      props: {
                        id: id,
                        invoiceStatus: invoiceStatus,
                        isEdit: invoiceStatus == 0
                      },
                      on: {
                        confirm: () => {
                          vm.saveSuccess();
                          vm.$xrkDialog.remove();
                        }
                      }
                    }
                  )
                }
              });
            }}
          >
            发票详情
          </el-button>
        </div>
      );
    }
  }
};
